/** A readable message from an axios error. FastAPI's `detail` is a string for our own errors but a LIST of objects for
 *  a request-validation 422; rendering that list as a React child would throw, so it is flattened to text here. */
export function apiErrorMessage(err: any, fallback = "Failed to save. Please try again."): string {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (detail && typeof detail === "object" && !Array.isArray(detail) && typeof detail.message === "string" && detail.message) return detail.message;
  if (Array.isArray(detail) && detail.length > 0) {
    return detail.map((d) => (typeof d === "string" ? d : [Array.isArray(d?.loc) ? d.loc.slice(1).join(".") : "", d?.msg].filter(Boolean).join(": "))).filter(Boolean).join("; ") || fallback;
  }
  return (typeof err?.message === "string" && err.message) || fallback;
}
